/**
 * LoginPage — Portal Type Router
 *
 * Reads `portalType` from PortalContext and renders the appropriate
 * login UI: AgentLoginPage (Cloudscape) or CustomerLoginPage (custom).
 * Shows a loading spinner while the platform config is being fetched.
 *
 * Requirements: 4.4, 2.1
 */

import React from 'react';
import { usePortal } from '../contexts/PortalContext';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { AgentLoginPage } from './AgentLoginPage';
import { CustomerLoginPage } from './CustomerLoginPage';

export const LoginPage: React.FC = () => {
  const { portalType, isLoading } = usePortal();

  if (isLoading) {
    return <LoadingSpinner size="big" message="Loading…" />;
  }

  return portalType === 'customer' ? <CustomerLoginPage /> : <AgentLoginPage />;
};

export default LoginPage;
